import { ModernAPI, extractErrorMessage } from './ModernAPI'

export const sendSupportMessage = (email, message) => ModernAPI.supportMessage({ email, message })

export { extractErrorMessage }
